export const FETCH_SHOWCASE = 'showcase/FETCH';
export const FETCH_SHOWCASE_SUCCESS = `${FETCH_SHOWCASE}_SUCCESS`;
export const FETCH_SHOWCASE_FAIL = `${FETCH_SHOWCASE}_FAIL`;
export const FETCH_SHOWCASE_CUSTOM = 'showcase/SHOWCASE_FETCH_CUSTOM';
export const FETCH_SHOWCASE_CUSTOM_SUCCESS = `${FETCH_SHOWCASE_CUSTOM}_SUCCESS`;

/* eslint-disable */

const SHOWCASE_DEFAULTS = {
  5: {
    home: {
      title: process.env.REACT_APP_TITLE_SHOWCASE_DEFAULTS || process.env.REACT_APP_HOME_SHOWCASE_TITLE || 'Troque seus pontos por produtos dos principais e-commerces.',
      titleOnlyCash: (process.env.REACT_APP_HOME_SHOWCASE_TITLE || 'Uma seleção de ofertas especiais para você.'),
      mobileTitle: (process.env.REACT_APP_HOME_SHOWCASE_TITLE_MOBILE || 'Produtos'),
    },
    'home-shopping': {
      title: process.env.REACT_APP_TITLE_SHOWCASE_DEFAULTS || process.env.REACT_APP_HOME_SHOWCASE_TITLE || 'Troque seus pontos por produtos dos principais e-commerces.',
      titleOnlyCash: (process.env.REACT_APP_HOME_SHOWCASE_TITLE || 'Uma seleção de ofertas especiais para você.'),
      mobileTitle: (process.env.REACT_APP_HOME_SHOWCASE_TITLE_MOBILE || 'Produtos')
    }
  },
  7: {
    home: {
      title: 'Vale-compras para você presentear.',
      mobileTitle: 'Produtos'
    }
  },
  4: {}
}

const updateShowcaseState = (state, identifier = 'home', isLoading = false, isError = false) => {
  const newState = { ...state };
  for (const key in newState) {
    if (newState.hasOwnProperty(key)) {
      const showcase = newState[key];

      if (showcase.hasOwnProperty(identifier)) {
        const identifierName = showcase.home;

        identifierName.isLoading = isLoading;
        identifierName.isError = isError;
      }
    }
  }

  return newState;
}
const transformArrayToObject = (arr) => {
  const newItems = {};

  arr.forEach((item) => {
    newItems[item.sku] = { ...item };
  });

  return newItems;
}

const ShowcasesReducer = (
  state = {
    ...updateShowcaseState(SHOWCASE_DEFAULTS, 'home', true, false),
    showcaseCustom: {
      isLoading: false,
      items: null,
    },
  },
  action = {},
) => {
  switch (action.type) {
    case FETCH_SHOWCASE:
      return {
        ...state,
        ...updateShowcaseState(SHOWCASE_DEFAULTS, 'home', true, false)
      };
    case FETCH_SHOWCASE_SUCCESS:
      const { payload: { data: { showcase, products, ...rest } } } = action;
      return {
        ...state,
        [showcase.type]: {
          ...state[showcase.type],
          [showcase.url]: {
            ...state[showcase.type][showcase.url],
            isLoading: false,
            ...showcase,
            title: (showcase.description && showcase.description !== '' ? showcase.description : state[showcase.type][showcase.url].title ),
            mobileTitle: (showcase.description && showcase.description !== '' ? showcase.description : state[showcase.type][showcase.url].mobileTitle ),
            products: transformArrayToObject(products),
            ...rest
          },
        },
        totalRowCount: rest.totalRowCount,
      };
    case FETCH_SHOWCASE_FAIL:
      const { payload } = action
      return {
        ...state,
        ...updateShowcaseState(SHOWCASE_DEFAULTS, 'home', false, true),
        [payload.type]: {
          ...state[payload.type],
          [payload.identifier]: {
            error: payload.error,
            isLoading: false,
          }
        }
      };
    case FETCH_SHOWCASE_CUSTOM_SUCCESS:
      const response = JSON.parse(process.env.REACT_APP_CUSTOM_SHOWCASE_DATA) || {};
      return {
        ...state,
        showcaseCustom: {
          isLoading: true,
          items: response.data || [],
        },
      };
    default:
      return { ...state };
  }
};

export default ShowcasesReducer
